<section class="accordion-block">
  <h3>Contacts</h3>
  @if (chargement()) {
    <p class="contacts-message">Chargement des contacts...</p>
  } @else if (erreur()) {
    <p class="contacts-message contacts-message-error">Impossible de charger les contacts.</p>
  } @else {
    @for (categorie of categories; track categorie.cle) {
      <button
        class="accordion-item"
        [class.accordion-item-open]="categorie.ouvert()"
        [disabled]="contacts(categorie.cle).length === 0"
        [attr.aria-expanded]="categorie.ouvert()"
        (click)="categorie.ouvert.set(!categorie.ouvert())"
      >
        {{ categorie.libelle }}
        <span class="accordion-count">{{ contacts(categorie.cle).length }}</span>
      </button>

      @if (categorie.ouvert()) {
        <div class="contacts-list">
          @for (contact of contacts(categorie.cle); track contact.id) {
            <article class="contact-card">
              <strong>{{ nomComplet(contact) }}</strong>

              @if (contact.entreprise?.raison; as raison) {
                <span class="contact-company">{{ raison }}</span>
              }
              @if (contact.email) {
                <a [href]="'mailto:' + contact.email" class="contact-line">{{ contact.email }}</a>
              }
              @if (contact.telephone) {
                <a [href]="'tel:' + contact.telephone" class="contact-line">{{
                  contact.telephone
                }}</a>
              }
              @if (contact.portable) {
                <a [href]="'tel:' + contact.portable" class="contact-line">{{
                  contact.portable
                }}</a>
              }
              @if (contact.portable2) {
                <a [href]="'tel:' + contact.portable2" class="contact-line">{{
                  contact.portable2
                }}</a>
              }

              @if (contact.installations.length) {
                <div class="contact-installations">
                  @for (installation of contact.installations; track installation.id) {
                    <a [routerLink]="['/installation', installation.id]">{{
                      installation.libelle
                    }}</a>
                  }
                </div>
              }
            </article>
          }
        </div>
      }
    }
  }
</section>
